import { TextField, Typography } from "@material-ui/core";
import { t } from "@/langs/useTranslation";
import modalConfirm from "../Modal/modalConfirm";
import { toast } from "@/apis/request";
import { checkLoginPassword } from "@/apis/apiCollection";

export function reConfirmPassword() {
  return new Promise((resolve, reject) => {
    let password = "";
    modalConfirm({
      title: t({ defaultMessage: "验证密码" }),
      content: (
        <>
          <Typography variant="subtitle1" gutterBottom>
            {t({ defaultMessage: "确认操作前请先请输入您的账户密码" })}
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            autoFocus
            type="password"
            style={{ width: 280 }}
            onChange={e => (password = e.target.value)}
          />
        </>
      ),
      onConfirm: async () => {
        if (!password.trim()) {
          toast.info(t({ defaultMessage: "请输入有效的密码" }));
          return Promise.reject();
        }
        try {
          await checkLoginPassword({ password });
          resolve();
        } catch (e) {
          // reject(e);
          return Promise.reject();
        }
      }
    });
  });
}
